import { useEffect } from 'react';
import { startAnalyticsRuntime } from '@/shared/lib/analytics/runtime';

export function AnalyticsRuntimeEffect() {
  useEffect(() => {
    const stopAnalyticsRuntime = startAnalyticsRuntime();

    return () => {
      stopAnalyticsRuntime();
    };
  }, []);

  return null;
}
